import * as ReduxAct from 'redux-act';
export function createAction() {
  if (arguments.length === 0) return createAction;
  return ReduxAct.createAction.apply(ReduxAct, arguments);
}
export function createReducer(defaultState) {
  return ReduxAct.createReducer({}, defaultState);
}